import { useQuery } from "react-query";
import { fetchHousesForInteractiveMap } from "./api";

export function useInteractiveMap(filters, options = {}) {
  return useQuery(
    ["fetchHousesForInteractiveMap", filters],
    () => fetchHousesForInteractiveMap(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
